var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Insights") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    fill: "#194A74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25,0 L0,0 L0,16.875 C0,17.220178 0.279822031,17.5 0.625,17.5 L17.5,17.5 L17.5,16.25 L1.25,16.25 L1.25,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,4.375 L13.125,4.375 L13.125,5.625 L15.3661875,5.625 L10.625,10.3661875 L7.941875,7.6830625 C7.69780544,7.43903213 7.30213206,7.43903213 7.0580625,7.6830625 L2.5,12.2411875 L3.3838125,13.125 L7.5,9.0088125 L10.183125,11.6919375 C10.4271946,11.9359679 10.8228679,11.9359679 11.0669375,11.6919375 L16.25,6.5088125 L16.25,8.75 L17.5,8.75 L17.5,4.375 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.b69297e9.svg";
export { ForwardRef as ReactComponent };